import { useContext, useEffect, useRef, useState } from 'react';
import { Context } from "../contexts/AppContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faSpinner } from "@fortawesome/free-solid-svg-icons";
import { postData, putData } from '../../lib/utils';
import { useParams } from 'react-router-dom';
import UploadImageBg from '../Gallery/UploadImageBg'; 

const StillImage = () => {
  const videoRef = useRef(null);
  const [isUploading, setIsUploading] = useState(false);
  const [isVideoUploading, setVideoUploading] = useState(false);

  const { value } = useContext(Context);
  const [appState, setAppState] = value;

  const { galleryId } = useParams();

  // Local states for immediate preview
  const [imgUrl, setImgUrl] = useState(null);
  const [videoUrl, setVideoUrl] = useState(null);

  // Sync local states with appState whenever it changes
  useEffect(() => {
    setImgUrl(appState.currentGalleryData?.backgroundMedia?.imgUrl || null);
    setVideoUrl(appState.currentGalleryData?.backgroundMedia?.videoUrl || null);
  }, [appState.currentGalleryData?.backgroundMedia?.imgUrl, appState.currentGalleryData?.backgroundMedia?.videoUrl]);

  // Open modal for video upload
  const btnHandler = () => {
    setAppState((prevState) => ({
      ...prevState,
      modalData: { ...prevState.modalData, type: "AddMediaModal", isOpen: true, openFrom: "videoBg" }
    }));
  };

  const deleteVideoBg=async()=>{

    try { 
                
                       
    const json = await putData(`galleries/gallery/${galleryId}/background`, {
      videoUrl: null
    });

    if (json) {
                // Update both appState and local state for instant preview
                setAppState((prevState) => ({
                  ...prevState,
                  currentGalleryData: {
                    ...prevState.currentGalleryData,
                    backgroundMedia: {
                      ...prevState.currentGalleryData.backgroundMedia,
                      videoUrl: json.backgroundMedia.imgUrl
                    }
                  }
                }));
                setVideoUrl(json.backgroundMedia.videoUrl);
               

              }
                      
                   } catch (error) {
                     console.error("Error deleting file:", error);
                   }

  }

  const deleteBgImg =async() =>{
 
    
   

       try { 
                const filePath =appState?.currentGalleryData?.backgroundMedia?.imgUrl
                      const _json = await postData("products/delete-file", {
                       fileName:filePath
                      })
                      if (_json) {
                       console.log("Delete Gallery");
                       
    const json = await putData(`galleries/gallery/${galleryId}/background`, {
      imgUrl: null
    });

    if (json) {
                // Update both appState and local state for instant preview
                setAppState((prevState) => ({
                  ...prevState,
                  currentGalleryData: {
                    ...prevState.currentGalleryData,
                    backgroundMedia: {
                      ...prevState.currentGalleryData.backgroundMedia,
                      imgUrl: json.backgroundMedia.imgUrl
                    }
                  }
                }));
                setImgUrl(json.backgroundMedia.imgUrl);
               

              }
                      }
                   } catch (error) {
                     console.error("Error deleting file:", error);
                   }

  }
  // Image upload success handler
  const imgUploadedDone = async (file) => {
    setVideoUploading(false);
    const imgPath = `${appState?.assetsUrl}/${file.name}`;

    const json = await putData(`galleries/gallery/${galleryId}/background`, {
      imgUrl: imgPath
    });

    if (json) {
      // Update both appState and local state for instant preview
      setAppState((prevState) => ({
        ...prevState,
        currentGalleryData: {
          ...prevState.currentGalleryData,
          backgroundMedia: {
            ...prevState.currentGalleryData.backgroundMedia,
            imgUrl: json.backgroundMedia.imgUrl
          }
        }
      }));
      setImgUrl(json.backgroundMedia.imgUrl);
      setIsUploading(false);
     //  window.location.reload();
    }
  };

  const uploadFailed = () => {
    alert("Oops Image Uploading Failed....");
  };

  const imgOnPrg = () => {
    setIsUploading(true);
  };

  return (
    <div className='space-y-4'>
      
      {/* Still Image Section */}
      <div className='border px-4 py-2 bg-[#f0f2f5] max-h-[290px] h-[290px]'>
        <div>Still Image</div>
        <div className='h-[150px] border'>

        {isUploading ? (
          <div className='w-[100%] text-center'>
            <FontAwesomeIcon icon={faSpinner} spin size="9x" className="text-yellow-800" />
          </div>
        ) : (
          <img
            key={Date.now()}
            className="w-full py-4 object-cover h-[150px]"
            src={
              imgUrl
                ? `${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${imgUrl}?t=${Date.now()}`
                : "../../../img/thumbnail/gallery/placeholder-image.jpg"
            }
            alt="Selected Preview"
          />
        )}

        <div className="text-xs text-gray-400 py-2">PNG, JPG, or JPEG (up to 40MB)</div>
      <div className='flex items-center'>
  <div className="flex-grow">
    <UploadImageBg  
      imgOnPrg={imgOnPrg} 
      imgUploadedDone={imgUploadedDone} 
      uploadFailed={uploadFailed} 
    />
  </div>
  <FontAwesomeIcon  
    icon={faTrash} 
    onClick={deleteBgImg}
    style={{ color: "white", backgroundColor:'#854d0e', border:'1px solid', padding:'12px' ,cursor:"pointer" }} 
    className="ml-2 flex-shrink-0"
  />
</div>
</div>
      </div>

      {/* Video Background Section */}
      <div className='relative border px-4 py-1 bg-[#f0f2f5]'>
        <div>Video Background</div>

        {videoUrl ? (
          <video
            className="w-full h-full object-cover"
            ref={videoRef}
            muted
            onLoadedMetadata={() => {
              if (videoRef.current) {
                videoRef.current.currentTime = 10;
              }
            }}
          >
            <source
              src={`${process.env.REACT_APP_VIDEO_DEST_BASE_PATH}${videoUrl}?t=${Date.now()}`}
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        ) : (
          <img
            key="thumb"
            className='w-[300px] py-2 object-cover'
            src={"../../../img/thumbnail/gallery/placeholder-image.jpg"}
            alt="Selected Preview"
          />
        )}

        <div className="text-xs text-gray-400 py-2">16:9 Aspect Ratio up to 30 sec</div>
      

             <div className='flex items-center'>
  <div className="flex-grow">
     <button
          onClick={btnHandler}
          className="btn-yellow"
        >
          Video Background
        </button>
  </div>
  <FontAwesomeIcon  
    icon={faTrash} 
    onClick={deleteVideoBg}
    style={{ color: "white", backgroundColor:'#854d0e', border:'1px solid', padding:'12px' ,cursor:"pointer" }} 
    className="ml-2 flex-shrink-0"
  />
</div>
      </div>

    </div>
  );
};

export default StillImage;
